import { useAuth } from "../context/AuthContext";

import {

    COMMUNITY_MASK

} from "../utils/CommunityAccess";

export default function useCommunityAccess() {

    const {

        user,
        accessMask

    } = useAuth();

    const userAccessMask =
        user?.accessMask ?? accessMask ?? 0;

    function hasAccess(category) {

        const categoryMask =

            COMMUNITY_MASK[category];
        console.log("hasAccess called with category:", category, "categoryMask:", categoryMask, "accessMask:", userAccessMask);
        if (!categoryMask) {

            return false;

        }

        return (

            userAccessMask & categoryMask

        ) !== 0;

    }

    const unlockedCommunities =

        Object.keys(COMMUNITY_MASK)

            .filter(

                category => hasAccess(category)

            );

    return {

        accessMask,

        hasAccess,

        unlockedCommunities,

        isLocked: category =>

            !hasAccess(category)

    };

}